import {CodeHighlightNode, CodeNode} from '@lexical/code';
import {AutoLinkNode, LinkNode} from '@lexical/link';
import {ListItemNode, ListNode} from '@lexical/list';
import {HorizontalRuleNode} from '@lexical/react/LexicalHorizontalRuleNode';
import {QuoteNode} from '@lexical/rich-text';
import {TableCellNode, TableRowNode} from '@lexical/table';
import {RedactionV2Node} from 'components/DSYS/editor/nodes/RedactionV2Node';
import {ParagraphNode} from 'lexical';
import {AISuggestionMarkNode} from 'plugins/aiRules/AISuggestionMarkNode';
// Keep enhanced-heading node imports direct: GuidanceDecoratorNode renders a nested
// RichTextArea, and routing registration through the barrel can split Lexical node identity.
import {BlockedEditNode} from 'plugins/enhancedHeadings/BlockedEditNode';
import {EnhancedHeadingNode} from 'plugins/enhancedHeadings/EnhancedHeadingNode';
import {GuidanceDecoratorNode} from 'plugins/enhancedHeadings/GuidanceDecoratorNode';
import {HeadingChevronDecoratorNode} from 'plugins/enhancedHeadings/HeadingChevronDecoratorNode';
import {HeadingControlsDecoratorNode} from 'plugins/enhancedHeadings/HeadingControlsDecoratorNode';
import {WordCountDecoratorNode} from 'plugins/enhancedHeadings/WordCountDecoratorNode';
import {EnhancedTableCellNode} from 'plugins/enhancedTableCells/EnhancedTableCellNode';
import {EnhancedTableNode} from 'plugins/enhancedTableCells/EnhancedTableNode';
import {TableCellDecoratorNode} from 'plugins/enhancedTableCells/TableCellDecoratorNode';

import {AuraVideoNode} from './nodes/AuraVideoNode';
import {CaptureNode} from './nodes/CaptureNode';
import {DeleteNode, InsertNode} from './nodes/DiffNodes';
import {DynamicNode} from './nodes/DynamicNode';
import {ExcludeWordcountNode} from './nodes/ExcludeWordcountNode';
import {HighlightNode} from './nodes/HighlightNode';
import {ImageNode} from './nodes/ImageNode';
import {KalturaNode} from './nodes/KalturaNode';
import {MentionNode} from './nodes/MentionNode';
import {PlaceholderNode} from './nodes/PlaceholderNode';
import {RedactionNode} from './nodes/RedactionNode';
import {ThreadAwareTextNode} from './nodes/ThreadAwareTextNode';
import {TypeaheadNode} from './nodes/TypeaheadNode';
import {VideoNode} from './nodes/VideoNode';
import {VimeoNode} from './nodes/VimeoNode';
import {YouTubeNode} from './nodes/YouTubeNode';

export const editorNodes = [
  AISuggestionMarkNode,
  EnhancedHeadingNode,
  GuidanceDecoratorNode,
  HeadingChevronDecoratorNode,
  HeadingControlsDecoratorNode,
  WordCountDecoratorNode,
  ParagraphNode,
  HighlightNode,
  // eslint-disable-next-line deprecation/deprecation -- Existing issue; this suppression was only added to allow existing lint warnings to be upgraded to errors.
  HorizontalRuleNode,
  ListNode,
  ListItemNode,
  QuoteNode,
  CodeNode,
  CodeHighlightNode,
  AutoLinkNode,
  LinkNode,
  YouTubeNode,
  BlockedEditNode,
  CaptureNode,
  AuraVideoNode,
  VimeoNode,
  MentionNode,
  PlaceholderNode,
  ExcludeWordcountNode,
  TypeaheadNode,
  DynamicNode,
  KalturaNode,
  ImageNode,
  RedactionNode,
  RedactionV2Node,
  VideoNode,
  ThreadAwareTextNode,
  EnhancedTableNode,
  TableRowNode,
  EnhancedTableCellNode,
  TableCellNode,
  TableCellDecoratorNode,
  InsertNode,
  DeleteNode,
];
